import { ApiBaseRequest } from './api-base-request';
import { ApiRequestOptions } from './api-request-options';
import { ApiParameters } from './api-parameters';
import { API_DI_CONFIG } from '../../../app-config.module';

export abstract class ApiPutRequest extends ApiBaseRequest
{
    private payload: any;

    public constructor(
        service: string,
        parameters: ApiParameters = undefined,
        options: ApiRequestOptions = undefined,
        payload: any = undefined,
        endpoint: string = API_DI_CONFIG.api.core.endpoint)
    {
        super(service, parameters, options, endpoint);
        this.payload = payload;
    }

    public get Payload(): any
    {
        return this.payload;
    }
}
